export const visit = (vm, at) => {
at({ "en": { "find-and-filter-data": { "visitors": { "unknownVisitor": "Unknown Visitor" } } } });
};